import { render } from "./FormField.vue?vue&type=template&id=1053581d&scoped=true&ts=true"
import script from "./FormField.vue?vue&type=script&lang=ts"
export * from "./FormField.vue?vue&type=script&lang=ts"

import "./FormField.vue?vue&type=style&index=0&id=1053581d&scoped=true&lang=css"
import "./FormField.vue?vue&type=style&index=1&id=1053581d&scoped=true&lang=scss"

import exportComponent from "/var/www/rewards/runners/admin/root/reward-admin/reward-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1053581d"]])

export default __exports__